module.exports = __webpack_public_path__ + "LohithsaisrinivasV-f1b11ed4.webp";